import React from 'react';
import { useTheme} from '../../../../hooks/useTheme'
import './ThemeSelector.css';

const ThemeSelector = ({ isCompact = false }) => {
  const { theme, setTheme } = useTheme();
  
  return (
    <div className={`theme-selector ${isCompact ? 'compact' : ''}`}>
      <div className="theme-selector-buttons">
        <button 
          className={`theme-btn ${theme === 'light' ? 'active' : ''}`}
          onClick={() => setTheme('light')}
          aria-label="Light theme"
          title="Light theme"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"></path>
          </svg>
          {!isCompact && <span>Light</span>}
        </button>
        
        <button 
          className={`theme-btn ${theme === 'dark' ? 'active' : ''}`}
          onClick={() => setTheme('dark')}
          aria-label="Dark theme"
          title="Dark theme"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
          {!isCompact && <span>Dark</span>}
        </button>
        
        <button 
          className={`theme-btn ${theme === 'high-contrast' ? 'active' : ''}`}
          onClick={() => setTheme('high-contrast')}
          aria-label="High contrast theme"
          title="High contrast"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 2v20M2 12h20"></path>
          </svg>
          {!isCompact && <span>High Contrast</span>}
        </button>
      </div>
    </div>
  );
};

export default ThemeSelector;